import { FormattedMessage } from 'react-intl';

import { useUserContext } from '@/context/UserContext.tsx';
import type { IntlMessageId } from '@/types/intl';

type PremiumWayMessageProps = {
  labelId: IntlMessageId;
  'data-e2e': string;
};

export function PremiumWayMessage({ labelId, 'data-e2e': dataE2e }: PremiumWayMessageProps) {
  const {
    currentUser: { userType },
  } = useUserContext();
  const isInternalSales = userType === 'Internal Sales';

  return (
    <div className="fs-12 lh-1" data-e2e={dataE2e}>
      <FormattedMessage id={labelId} values={{ isInternalSales }} />
    </div>
  );
}

